var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (myAccountsUrl, next, t) {
buf.push("<div class=\"my-accounts-wrapper\"><iframe" + (jade.attr("src", myAccountsUrl, true, true)) + " class=\"my-accounts-container\"></iframe><footer class=\"my-accounts-footer\"><p>" + (jade.escape(null == (jade_interp = t('myaccounts info')) ? "" : jade_interp)) + "</p><div class=\"controls\"><a" + (jade.attr("href", next, true, true)) + " role=\"button\" class=\"next\">" + (jade.escape(null == (jade_interp = t('myaccounts next')) ? "" : jade_interp)) + "</a></div></footer></div>");}.call(this,"myAccountsUrl" in locals_for_with?locals_for_with.myAccountsUrl:typeof myAccountsUrl!=="undefined"?myAccountsUrl:undefined,"next" in locals_for_with?locals_for_with.next:typeof next!=="undefined"?next:undefined,"t" in locals_for_with?locals_for_with.t:typeof t!=="undefined"?t:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/views/templates/my_accounts.jade
// module id = 16
// module chunks = 0